//Include Both Helper File with needed methods
import {
  postJwtLogin,
  postLogin
} from "../../../helpers/fakebackend_helper";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import { getBusinessBySellerId } from "helpers/backend_helper";
import { businessBySellerId } from "live-slices/thunk";
import { getAuthMe } from "slices/thunks";
import { Constant } from "utils/enums";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
} from "./reducer";
import { handleLogout } from "helpers/api_helper";
import { Environment } from "environment";

export const loginUser = (user: any, navigate: any) => async (dispatch: any) => {
  try {
    let response;
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      let fireBaseBackend: any = getFirebaseBackend();
      response = fireBaseBackend.loginUser(user.email, user.password);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = postJwtLogin({
        email: user.email,
        password: user.password,
      });
    } else if (Environment.apiUrl) {
      response = postLogin({
        userName: user.userName,
        password: user.password,
      });
    }

    const data = await response;

    if (data) {
      localStorage.setItem(
        Constant.access_token,
        JSON.stringify(data.access_token)
      );
      localStorage.setItem(
        Constant.refresh_token,
        JSON.stringify(data.refresh_token)
      );


        // Navigate first to avoid user delay

        try {
          const authResponse: any = await dispatch(getAuthMe()).unwrap();
          console.log("Auth Response:", authResponse);

          const userMain = JSON.stringify(authResponse);
          localStorage.setItem(Constant.user, userMain);
          dispatch(loginSuccess(JSON.parse(userMain)));

          const sellerId = authResponse?.sub;
          if (sellerId) {
            dispatch(businessBySellerId(sellerId));
            navigate("/manage-products");
          } else {
            console.warn("Seller ID is undefined in Auth Response.");
          }
        } catch (authError) {
          console.error("Error in getAuthMe:", authError);
        }
      
    } else {
      console.warn("Login response returned no data.");
    }
  } catch (error: any) {
    console.error("Error in loginUser:", error);
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    handleLogout();
    let fireBaseBackend: any = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const socialLogin =
  (type: any, history: any) => async (dispatch: any) => {
    try {
      let response;

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const fireBaseBackend: any = getFirebaseBackend();
        response = fireBaseBackend.socialLoginUser(type);
      }
      //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;
      if (socialdata) {
        sessionStorage.setItem("authUser", JSON.stringify(response));
        dispatch(loginSuccess(response));
        history("/dashboard");
      }
    } catch (error: any) {
      dispatch(apiError(error));
    }
  };

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
